export const makeDraggable = (target: HTMLElement) => {
  let isPress = false,
    prevPosX = 0,
    prevPosY = 0

  const start = (e: MouseEvent | TouchEvent) => {
    if (isPress) return

    const touch = e instanceof TouchEvent ? e.touches[0] : e

    prevPosX = touch.clientX
    prevPosY = touch.clientY

    isPress = true
    // Desktop
    window.addEventListener("mousemove", move)

    // Mobile
    window.addEventListener("touchmove", move, { passive: false })
  }

  const move = (e: MouseEvent | TouchEvent) => {
    if (!isPress) return
    target.classList.add("dragged")

    const touch = e instanceof TouchEvent ? e.touches[0] : e

    const posX = prevPosX - touch.clientX
    const posY = prevPosY - touch.clientY

    prevPosX = touch.clientX
    prevPosY = touch.clientY

    target.style.left = target.offsetLeft - posX + "px"
    target.style.top = target.offsetTop - posY + "px"

    e.preventDefault()
  }

  const end = () => {
    isPress = false

    // Desktop
    window.removeEventListener("mousemove", move)

    // Mobile
    window.removeEventListener("touchmove", move)
  }

  // Desktop
  target.addEventListener("mousedown", start)
  target.addEventListener("mouseup", end)

  // Mobile
  target.addEventListener("touchstart", start, { passive: false })
  target.addEventListener("touchend", end)
}
